var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({staticClass:"e-control e-input",attrs:{"type":"text","autocomplete":"off","autocapitalize":"off","spellcheck":"false"}},'input',_vm.$_attrs,false),_vm.$_listeners))}
var staticRenderFns = []

export { render, staticRenderFns }